export const INTL_NUMBER_FORMAT = new Intl.NumberFormat(navigator.language)
